import Vue from 'vue';
import SnackBar from '@/views/components/mensagemSnackBar.vue'; // Ajuste o caminho conforme necessário

const SnackBarConstructor = Vue.extend(SnackBar);

export const snackConfig = {
  position: 'bottom-right',
  time: 3000,
  methods: [
    { name: 'success', color: '#48BB78' },
    { name: 'error', color: '#F56565' },
    { name: 'warning', color: '#ECC94B' },
  ],
};

const snackBar = {
  install(Vue) {
    // Adiciona o método $snack ao Vue
    Vue.prototype.$snack = ({ message, timeout }) => {
      const instance = new SnackBarConstructor({
        data() {
          return {
            message: message,
            color: '#F56565', // Default color, caso seja necessário
            timeout: timeout || snackConfig.time,
            position: snackConfig.position, // Usando a posição da configuração
          };
        },
      });

      // Monta a instância do componente
      instance.$mount();

      // Adiciona o componente ao body
      document.body.appendChild(instance.$el);

      // Abre o Snackbar
      instance.open();

      // Remover o componente após o tempo especificado
      setTimeout(() => {
        instance.$el.remove(); // Remove o snackbar do DOM após a exibição
      }, timeout || snackConfig.time);
    };

    // Métodos de atalho para tipos específicos de Snackbar
    snackConfig.methods.forEach(method => {
      Vue.prototype.$snack[method.name] = (message) => {
        Vue.prototype.$snack({
          message, 
          timeout: snackConfig.time // Usando o tempo definido na configuração
        });

        // Atualiza a cor no Snackbar diretamente
        const instance = new SnackBarConstructor({
          data() {
            return {
              message: message,
              color: method.color, // Usando a cor da configuração
              timeout: snackConfig.time,
              position: snackConfig.position,
            };
          },
        });

        // Monta a instância do componente
        instance.$mount();

        // Adiciona o componente ao body
        document.body.appendChild(instance.$el);

        // Abre o Snackbar
        instance.open();

        // Remover o componente após o tempo especificado
        setTimeout(() => {
          instance.$el.remove(); // Remove o snackbar do DOM após a exibição
        }, snackConfig.time);
      };
    });
  },
};

export default snackBar;
